import axiosInstance from "../../../../../shared/api/axiosInstance.js";
import { baseUrl, GET_ALL_FEILD, CREATE_ADVERTISMENT_DATA } from "../../../../../shared/api/endpoints.js";
import { configReq } from "../../../../../shared/lib/functions.js";
/** Keeps the existing GET request and response contract. */
export function getAllFeild(token) {
  return axiosInstance(`${baseUrl}/${GET_ALL_FEILD}?Page=${1}&Limit=${2000}`, configReq(token));
}

/** Keeps the existing GET request and response contract. */
export function createAdvertismentData(id, category, value, token) {
  return axiosInstance(`${baseUrl}/${CREATE_ADVERTISMENT_DATA}`, {
    advertisementId: id,
    fieldId: category?.id,
    value
  }, configReq(token));
}
